import { integrations } from "../data/marketingContent";
import { SectionHeading } from "./SectionHeading";

export function Integrations() {
  return (
    <section className="section-wrap">
      <div className="mx-auto max-w-7xl px-5 sm:px-6 lg:px-8">
        <SectionHeading
          eyebrow="Integrations"
          title="Accurate integration status, without over-claiming."
          body="PulsePanels already includes Stripe billing and taxi display data paths. Smart Ads is shown as in progress, while calendar and meeting-room integrations remain coming soon."
          center
        />

        <div className="mt-12 grid gap-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {integrations.map((integration) => {
            const Icon = integration.icon;
            return (
              <article className="integration-card" key={integration.title}>
                <div className="flex items-center justify-between gap-3">
                  <span className="feature-icon">{Icon ? <Icon size={21} /> : null}</span>
                  <span className={`status-chip status-chip-${integration.tone ?? "soon"}`}>
                    {integration.status}
                  </span>
                </div>
                <h3>{integration.title}</h3>
                <p>{integration.body}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
